<template>
    <div class="menus">
        <Menu mode="horizontal" theme="light" :active-name="activeName" accordion>
            <template v-for="(item, index) in menuList" >
                <MenuItem class="menuItems" :name="item.name" v-if="item.path" style="text-align: center; font-size: 16px" :to="item.path">
                    <Icon v-if="item.icon" :type="item.icon" size="18" />
                    <strong>{{item.name}}</strong>
                </MenuItem>
                <Submenu  class="menuItems" :name="item.name" v-if="item.children" style="text-align: center; font-size: 16px">
                    <template slot="title">
                        <strong>{{item.name}}</strong>
                    </template>
                    <MenuItem v-for="(menuItem, val) in item.children" :key="val" :name="menuItem.name" :to="menuItem.path">{{menuItem.name}}</MenuItem>
                </Submenu>
            </template>
        </Menu>
    </div>
</template>

<script>
export default {
    data() {
        return {
            activeName: '首页',
            menuList: [
                { name: "首页", path: '/', icon: "ios-home-outline" },
                { name: "托盘共享", path: '/pallet-bank' },
                {
                    name: "普通租赁",
                    children: [
                        { name: '普通租赁', path: '/lease' },
                        { name: '应用模式', path: '/industry-case' },
                        // { name: '产品方案', path: '/product-solution' },
                    ]
                },
                { name: "工厂拼单", path: '/share-production' },
                { name: "普托商城", path: '/mall' },
                { name: '智慧托盘', path: '/solution' }, 
                { name: "增值服务",children:[
                    { name: "企业回收", path: '/companyRecycle' },
                ] },
                { name: "媒体中心",children:[
                    {name:'媒体中心',path:'/media-center'},
                    {name:'行业资讯',path:'/industry-info'},

                ] },
            ]
        }
    },
    watch: {
        '$route': function (newVal) {
            this.getMenuName()
        }
    },

    mounted() {
        this.getMenuName()
    },
    methods: {
        getMenuName() {
            let path = this.$route.path;
            this.menuList.forEach(item => {
                if (!item.children) {
                    if (item.path === path) {
                        window.sessionStorage.setItem('pathName', item.name)
                        this.activeName = item.name;
                    } else {
                        this.activeName = window.sessionStorage.getItem('pathName')
                    }

                } else {
                    item.children.filter(element => {
                        if (element.path === path) {
                            window.sessionStorage.setItem('pathName', element.name)
                            this.activeName = element.name;
                        } else {
                            this.activeName = window.sessionStorage.getItem('pathName')
                        }
                    });
                }
            })

        }
    }
}
</script>
<style lang="scss" scoped>
/deep/ .ivu-menu-light.ivu-menu-horizontal .ivu-menu-item-active,
.ivu-menu-light.ivu-menu-horizontal .ivu-menu-item:hover,
.ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu-active,
.ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu:hover {
    color: #ff9000;
    border-bottom: 2px solid #ff9000;
}
/deep/
    .ivu-menu-horizontal
    .ivu-menu-submenu
    .ivu-select-dropdown
    .ivu-menu-item {
    height: auto;
    line-height: normal;
    border-bottom: 0;
    float: none;
}
.menus{
    position: relative;
    z-index: 1;
}
.menuItems{
    display: inline-block;
    width: 135px;
    // padding:0 23px;
}
</style>
